
  import { reactive } from "vue";
  import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";
  
  export default {
    name: "ManualRegistration",
    inheritAttrs: false,
    components: {
      DynamicForm
    },
    setup() {    
      const request = reactive({
        apiLoadMethod: "api/anonymousForm/loadForm",
        apiSaveMethod: "api/anonymousForm/saveForm",
        form: "ManualRegistration",
        page: "ManualRegistration",
        remoteId: "",
        waitForResponse: true
        
      });
  
      return {
        request
      };
    }
  };
  